// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__11AVr","selected":"Chip_selected__2UvM9"};